import { Link, useParams } from "react-router-dom";
import { usePublicSiteData } from "./PublicSiteContext";
import { StageImage, useStage } from "./StagedImageLoading";

interface PublicAboutProps {
  full?: boolean;
}

const PublicAbout = ({ full = false }: PublicAboutProps) => {
  const { slug } = useParams<{ slug: string }>();
  const website = usePublicSiteData();

  const imageUrl =
    website?.settings?.taglineImageUrl ??
    website?.promoImages?.[1]?.imageUrl ??
    website?.beforeAfter?.[0]?.beforeImageUrl ??
    website?.organization?.bannerUrl;
  useStage("tagline", imageUrl ? 1 : 0);

  if (!website) return null;

  const base = `/${slug ?? ""}`;
  const org = website.organization;

  const description =
    org.description ||
    org.tagline ||
    `${org.name} combines advanced technology with compassionate care to deliver results you can see and trust.`;

  return (
    <section className="psite-section psite-section--tint">
      <div className="psite-section__inner">
        <div className="psite-about">
          <div className="psite-about__media">
            {imageUrl ? (
              <StageImage stage="tagline" src={imageUrl} alt="" />
            ) : (
              <div className="psite-about__media--empty">{org.name}</div>
            )}
          </div>
          <div className="psite-about__content">
            <h2>{org.tagline || "Excellence in every detail"}</h2>
            <p
              className={
                full
                  ? "psite-about__desc psite-about__desc--full"
                  : "psite-about__desc"
              }
            >
              {description}
            </p>
            {!full && (
              <Link
                className="psite-btn psite-btn--primary"
                to={`${base}/about-us`}
              >
                Learn More
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicAbout;